// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BREAKPOINTS */
@media (max-width: 767.98px) {
  [aria-expanded=false] ~ .Menubar_menubarWrap__6rCcF {
    display: none;
  }
}
@media (min-width: 768px) {
  .Menubar_menubarWrap__6rCcF > div > div:not(:first-child) {
    display: none;
  }
  .Menubar_menubarWrap__6rCcF > div > div:first-child {
    display: contents;
  }
}
@media (max-width: 767.98px) {
  .Menubar_menubarWrap__6rCcF {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 15%;
    background: var(--background-color-2);
    z-index: var(--menuIndex);
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
  }
}
.Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm {
  position: relative;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: flex-end;
}
@media (max-width: 767.98px) {
  .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm {
    height: 100vh;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
}
@media (min-width: 768px) {
  .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm::before {
    content: "";
    position: absolute;
    display: block;
    height: 1px;
    width: 300vw;
    left: -100vw;
    top: 0;
    background: var(--foreground-color-3);
    opacity: 0.5;
  }
}
.Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarLogoWrap__gO4GA {
  margin-right: auto;
}
@media (max-width: 767.98px) {
  .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarLogoWrap__gO4GA {
    padding: 1em;
  }
}
.Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2 {
  position: relative;
}
@media (max-width: 767.98px) {
  .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2 {
    width: 100%;
  }
}
@media (min-width: 768px) {
  .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2 {
    margin-left: 1px;
    height: 60px;
  }
}
@media (max-width: 767.98px) {
  .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2 .Menubar_menubarItemSubmenu__BA2hq {
    width: 100%;
    position: relative !important;
    transform: none !important;
  }
}
.Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2 .Menubar_menubarItemSubmenu__BA2hq .Menubar_menubarItemSubmenu__BA2hq {
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.25), inset 0.5em 0 0 -1px var(--foreground-color-1);
  padding-left: 0.5em;
}
.Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2 .Menubar_menubarItem__dziAO {
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border: none;
  background: none;
  color: var(--foreground-color-3);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px 0 21px;
  height: 100%;
}
@media (max-width: 767.98px) {
  .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2 .Menubar_menubarItem__dziAO {
    height: 60px;
    width: 100%;
    justify-content: flex-start;
  }
}
.Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2 .Menubar_menubarItem__dziAO .Menubar_submenuIndicator__5ozzp {
  position: absolute;
  height: 1em;
  width: 1em;
  bottom: 0.25em;
  left: 50%;
  margin-left: -0.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}
.Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2 .Menubar_menubarItem__dziAO .Menubar_submenuIndicator__5ozzp.Menubar_selected__6eMA0 {
  transform: rotate(180deg);
}
@media (max-width: 767.98px) {
  .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2 .Menubar_menubarItem__dziAO .Menubar_submenuIndicator__5ozzp {
    top: 50%;
    margin-top: -0.5em;
    right: 1.5em;
    left: auto;
    left: initial;
    bottom: auto;
    bottom: initial;
    margin-left: 0;
  }
}
.Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2 .Menubar_menubarItem__dziAO::after {
  content: "";
  display: flex;
  position: absolute;
  z-index: -1;
  height: 0;
  width: 0;
  left: 50%;
  top: 50%;
  border-radius: 1000px;
  border: 0 solid var(--warn);
  background: var(--background-color-1);
}
.Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2 .Menubar_menubarItem__dziAO[aria-expanded=true]:not(:hover):not(.focus-visible) {
  background: var(--background-color-3);
}
.Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2 .Menubar_menubarItem__dziAO:focus, .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2 .Menubar_menubarItem__dziAO.focus-visible {
  outline: none;
}
.Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2 .Menubar_menubarItem__dziAO:hover, .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2 .Menubar_menubarItem__dziAO.focus-visible {
  color: var(--foreground-color-1);
  transition: all 0.3s ease-in;
  box-shadow: 8px 0 5px -5px var(--background-color-3-alpha), -8px 0 5px -5px var(--background-color-3-alpha);
}
.Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2 .Menubar_menubarItem__dziAO:hover::after, .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2 .Menubar_menubarItem__dziAO.focus-visible::after {
  transition: all 0.3s ease-in;
  --size: 600px;
  height: var(--size);
  width: var(--size);
  margin-top: calc(-0.5 * var(--size));
  margin-left: calc(-0.5 * var(--size));
  border-width: 100px;
}
.Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2::before {
  --divisorHeight: 30px;
  content: "";
  display: block;
  position: absolute;
  height: var(--divisorHeight);
  width: 1px;
  background: var(--foreground-color-3);
  opacity: 0.5;
  top: 50%;
  margin-top: calc(-0.5 * var(--divisorHeight));
  left: -1px;
}
@media (max-width: 767.98px) {
  .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2::before {
    height: 1px;
    width: var(--divisorHeight);
    margin-top: 0;
    left: 50%;
    margin-left: calc(-0.5 * var(--divisorHeight));
    top: auto;
    top: initial;
  }
}
@media (max-width: 767.98px) {
  .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2::before {
    top: 0;
  }
}
.Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2:last-child::after {
  --divisorHeight: 30px;
  content: "";
  display: block;
  position: absolute;
  height: var(--divisorHeight);
  width: 1px;
  background: var(--foreground-color-3);
  opacity: 0.5;
  top: 50%;
  margin-top: calc(-0.5 * var(--divisorHeight));
  right: 0;
}
@media (max-width: 767.98px) {
  .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2:last-child::after {
    height: 1px;
    width: var(--divisorHeight);
    margin-top: 0;
    left: 50%;
    margin-left: calc(-0.5 * var(--divisorHeight));
    top: auto;
    top: initial;
  }
}
@media (max-width: 767.98px) {
  .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2:last-child::after {
    bottom: 0;
    right: auto;
    right: initial;
  }
}
.Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2:focus-within::before, .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2:focus-within + *::before, .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2:hover::before, .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2:hover + *::before {
  transition: all 0.3s ease;
}
@media (min-width: 768px) {
  .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2:focus-within::before, .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2:focus-within + *::before, .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2:hover::before, .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2:hover + *::before {
    height: 100%;
    top: 0;
    margin-top: 0;
  }
}
@media (max-width: 767.98px) {
  .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2:focus-within::before, .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2:focus-within + *::before, .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2:hover::before, .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2:hover + *::before {
    width: 100%;
    left: 0;
    margin-left: 0;
  }
}
.Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2:focus-within:last-child::after, .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2:hover:last-child::after {
  transition: all 0.3s ease;
}
@media (min-width: 768px) {
  .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2:focus-within:last-child::after, .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2:hover:last-child::after {
    height: 100%;
    top: 0;
    margin-top: 0;
  }
}
@media (max-width: 767.98px) {
  .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2:focus-within:last-child::after, .Menubar_menubarWrap__6rCcF .Menubar_menubar__wO3lm .Menubar_menubarItemWrap__Bk9P2:hover:last-child::after {
    width: 100%;
    left: 0;
    margin-left: 0;
  }
}

.nightMode .Menubar_menubarItem__dziAO:not(:hover)[aria-expanded=true] {
  color: var(--background-color-1);
}`, "",{"version":3,"sources":["webpack://./src/core/_breakpoints.scss","webpack://./src/views/Template/components/Menu/Menubar.module.scss"],"names":[],"mappings":"AAAA,gBAAA;AA2BI;ECzBF;IACE,aAAA;EACF;AACF;ADEI;ECGE;IACE,aAAA;EAFN;EAII;IACE,iBAAA;EAFN;AACF;ADcI;ECrBJ;IAaI,eAAA;IACA,MAAA;IACA,SAAA;IACA,OAAA;IACA,UAAA;IACA,qCAAA;IACA,yBAAA;IACA,uCAAA;EAFF;AACF;AAGE;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;AADJ;ADLI;ECCF;IAOI,aAAA;IACA,sBAAA;IACA,2BAAA;IACA,uBAAA;EACJ;AACF;ADjCI;ECkCE;IAEE,WAAA;IACA,kBAAA;IACA,cAAA;IACA,WAAA;IACA,YAAA;IACA,YAAA;IACA,MAAA;IACA,qCAAA;IACA,YAAA;EACN;AACF;AACI;EACE,kBAAA;AACN;AD7BI;EC2BA;IAGI,YAAA;EAGN;AACF;AADI;EACE,kBAAA;AAGN;ADrCI;ECiCA;IAGI,WAAA;EAKN;AACF;AD9DI;ECqDA;IAMI,gBAAA;IACA,YAAA;EAON;AACF;ADhDI;EC0CE;IAEI,WAAA;IACA,6BAAA;IACA,0BAAA;EAQR;AACF;AAPQ;EACE,uFAAA;EAEA,mBAAA;AAQV;AALM;EAME,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,YAAA;AAER;ADxEI;ECsDE;IAEI,YAAA;IACA,WAAA;IACA,2BAAA;EAoBR;AACF;AARQ;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AAUV;AATU;EACE,yBAAA;AAWZ;AD9FI;ECuEI;IAeI,QAAA;IACA,kBAAA;IACA,YAAA;IACA,UAAA;IAAA,aAAA;IACA,YAAA;IAAA,eAAA;IACA,cAAA;EAYV;AACF;AAVQ;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,qBAAA;EACA,2BAAA;EACA,qCAAA;AAYV;AAVQ;EACE,qCAAA;AAYV;AAVQ;EAEE,aAAA;AAWV;AATQ;EAEE,gCAAA;EACA,4BAAA;EACA,2GAAA;AAUV;AARU;EACE,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,oCAAA;EACA,qCAAA;EACA,mBAAA;AAUZ;AAcM;EAnBE,qBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,4BAAA;EACA,UAAA;EACA,qCAAA;EACA,YAAA;EACA,QAAA;EACA,6CAAA;EAYA,UAAA;AAHR;ADtJI;ECuJE;IARI,WAAA;IACA,2BAAA;IACA,aAAA;IACA,SAAA;IACA,8CAAA;IACA,SAAA;IAAA,YAAA;EAWR;AACF;ADhKI;ECuJE;IAII,MAAA;EASR;AACF;AANQ;EA3BA,qBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,4BAAA;EACA,UAAA;EACA,qCAAA;EACA,YAAA;EACA,QAAA;EACA,6CAAA;EAoBE,QAAA;AAiBV;ADlLI;EC+JI;IAhBE,WAAA;IACA,2BAAA;IACA,aAAA;IACA,SAAA;IACA,8CAAA;IACA,SAAA;IAAA,YAAA;EAuCR;AACF;AD5LI;EC+JI;IAII,SAAA;IACA,WAAA;IAAA,cAAA;EA6BV;AACF;AAXQ;EAZE,yBAAA;AA0BV;ADzNI;EC2MI;IAVI,YAAA;IACA,MAAA;IACA,aAAA;EA4BV;AACF;AD5MI;ECuLI;IALI,WAAA;IACA,OAAA;IACA,cAAA;EA8BV;AACF;AAvBU;EAjBA,yBAAA;AA2CV;AD1OI;ECgNM;IAfE,YAAA;IACA,MAAA;IACA,aAAA;EA6CV;AACF;AD7NI;EC4LM;IAVE,WAAA;IACA,OAAA;IACA,cAAA;EA+CV;AACF;;AA9BE;EACE,gCAAA;AAiCJ","sourcesContent":["/* BREAKPOINTS */\n@mixin breakpoint-up($point) {\n  @if $point == sm {\n    @media (min-width: 576px) {\n      @content;\n    }\n  } @else if $point == md {\n    @media (min-width: 768px) {\n      @content;\n    }\n  } @else if $point == lg {\n    @media (min-width: 992px) {\n      @content;\n    }\n  } @else if $point == xl {\n    @media (min-width: 1200px) {\n      @content;\n    }\n  }\n}\n\n@mixin breakpoint-down($point) {\n  @if $point == xs {\n    @media (max-width: 575.98px) {\n      @content;\n    }\n  } @else if $point == sm {\n    @media (max-width: 767.98px) {\n      @content;\n    }\n  } @else if $point == md {\n    @media (max-width: 991.98px) {\n      @content;\n    }\n  } @else if $point == lg {\n    @media (max-width: 1199.98px) {\n      @content;\n    }\n  }\n}\n","@import \"core/_breakpoints.scss\";\n@include breakpoint-down(sm) {\n  [aria-expanded=\"false\"] ~ .menubarWrap {\n    display: none;\n  }\n}\n.menubarWrap {\n  @include breakpoint-up(md) {\n    //disables scrollbars\n    > div {\n      > div:not(:first-child) {\n        display: none;\n      }\n      > div:first-child {\n        display: contents;\n      }\n    }\n  }\n  @include breakpoint-down(sm) {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 15%;\n    background: var(--background-color-2);\n    z-index: var(--menuIndex);\n    box-shadow: 0 0 5px rgba(black, 0.25);\n  }\n  .menubar {\n    position: relative;\n    display: flex;\n    height: 100%;\n    align-items: center;\n    justify-content: flex-end;\n    @include breakpoint-down(sm) {\n      height: 100vh;\n      flex-direction: column;\n      justify-content: flex-start;\n      align-items: flex-start;\n    }\n    @include breakpoint-up(md) {\n      &::before {\n        // horizontal line that splits menu in two\n        content: \"\";\n        position: absolute;\n        display: block;\n        height: 1px;\n        width: 300vw;\n        left: -100vw;\n        top: 0;\n        background: var(--foreground-color-3);\n        opacity: 0.5;\n      }\n    }\n    .menubarLogoWrap {\n      margin-right: auto;\n      @include breakpoint-down(sm) {\n        padding: 1em;\n      }\n    }\n    .menubarItemWrap {\n      position: relative;\n      @include breakpoint-down(sm) {\n        width: 100%;\n      }\n      @include breakpoint-up(md) {\n        margin-left: 1px;\n        height: 60px;\n      }\n      .menubarItemSubmenu {\n        @include breakpoint-down(sm) {\n          width: 100%;\n          position: relative !important;\n          transform: none !important;\n        }\n        .menubarItemSubmenu {\n          box-shadow: 0 0 5px rgba(black, 0.25),\n            inset 0.5em 0 0 -1px var(--foreground-color-1);\n          padding-left: 0.5em;\n        }\n      }\n      .menubarItem {\n        @include breakpoint-down(sm) {\n          height: 60px;\n          width: 100%;\n          justify-content: flex-start;\n        }\n        cursor: pointer;\n        position: relative;\n        overflow: hidden;\n        border: none;\n        background: none;\n        color: var(--foreground-color-3);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 0 20px 0 21px;\n        height: 100%;\n        .submenuIndicator {\n          position: absolute;\n          height: 1em;\n          width: 1em;\n          bottom: 0.25em;\n          left: 50%;\n          margin-left: -0.5em;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          transition: all 0.3s ease;\n          &.selected {\n            transform: rotate(180deg);\n          }\n          @include breakpoint-down(sm) {\n            top: 50%;\n            margin-top: -0.5em;\n            right: 1.5em;\n            left: unset;\n            bottom: unset;\n            margin-left: 0;\n          }\n        }\n        &::after {\n          content: \"\";\n          display: flex;\n          position: absolute;\n          z-index: -1;\n          height: 0;\n          width: 0;\n          left: 50%;\n          top: 50%;\n          border-radius: 1000px;\n          border: 0 solid var(--warn);\n          background: var(--background-color-1);\n        }\n        &[aria-expanded=\"true\"]:not(:hover):not(:global(.focus-visible)) {\n          background: var(--background-color-3);\n        }\n        &:focus,\n        &:global(.focus-visible) {\n          outline: none;\n        }\n        &:hover,\n        &:global(.focus-visible) {\n          color: var(--foreground-color-1);\n          transition: all 0.3s ease-in;\n          box-shadow: 8px 0 5px -5px var(--background-color-3-alpha),\n            -8px 0 5px -5px var(--background-color-3-alpha);\n          &::after {\n            transition: all 0.3s ease-in;\n            --size: 600px;\n            height: var(--size);\n            width: var(--size);\n            margin-top: calc(-0.5 * var(--size));\n            margin-left: calc(-0.5 * var(--size));\n            border-width: 100px;\n          }\n        }\n      }\n      @mixin env-menu-divisor {\n        --divisorHeight: 30px;\n        content: \"\";\n        display: block;\n        position: absolute;\n        height: var(--divisorHeight);\n        width: 1px;\n        background: var(--foreground-color-3);\n        opacity: 0.5;\n        top: 50%;\n        margin-top: calc(-0.5 * var(--divisorHeight));\n        @include breakpoint-down(sm) {\n          height: 1px;\n          width: var(--divisorHeight);\n          margin-top: 0;\n          left: 50%;\n          margin-left: calc(-0.5 * var(--divisorHeight));\n          top: unset;\n        }\n      }\n      &::before {\n        @include env-menu-divisor;\n        left: -1px;\n        @include breakpoint-down(sm) {\n          top: 0;\n        }\n      }\n      &:last-child {\n        &::after {\n          @include env-menu-divisor;\n          right: 0;\n          @include breakpoint-down(sm) {\n            bottom: 0;\n            right: unset;\n          }\n        }\n      }\n      &:focus-within,\n      &:hover {\n        @mixin divisorTransition {\n          transition: all 0.3s ease;\n          @include breakpoint-up(md) {\n            height: 100%;\n            top: 0;\n            margin-top: 0;\n          }\n          @include breakpoint-down(sm) {\n            width: 100%;\n            left: 0;\n            margin-left: 0;\n          }\n        }\n        &::before,\n        & + *::before {\n          @include divisorTransition;\n        }\n        &:last-child {\n          &::after {\n            @include divisorTransition;\n          }\n        }\n      }\n    }\n  }\n}\n\n:global(.nightMode) {\n  .menubarItem:not(:hover)[aria-expanded=\"true\"] {\n    color: var(--background-color-1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menubarWrap": `Menubar_menubarWrap__6rCcF`,
	"menubar": `Menubar_menubar__wO3lm`,
	"menubarLogoWrap": `Menubar_menubarLogoWrap__gO4GA`,
	"menubarItemWrap": `Menubar_menubarItemWrap__Bk9P2`,
	"menubarItemSubmenu": `Menubar_menubarItemSubmenu__BA2hq`,
	"menubarItem": `Menubar_menubarItem__dziAO`,
	"submenuIndicator": `Menubar_submenuIndicator__5ozzp`,
	"selected": `Menubar_selected__6eMA0`
};
export default ___CSS_LOADER_EXPORT___;
